module.exports = __webpack_public_path__ + "media/4x3/na-bb49a403.svg";